<script>
  import adapter from "webrtc-adapter";
  import Links from "./_links.svelte";
  import Quagga from "Quagga";
  import { tick, onDestroy } from "svelte";

  let errors = [];
  let results = [];
  let cameras = [];
  let cameraId
  cameraId = localStorage.getItem('camera', cameraId)

  results.filter((value, index, self) => self.indexOf(value) === index);

  function startStream() {
    console.log("restricting to", cameraId);
    Quagga.init(
      {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          target: document.querySelector("#quagga"),
          constraints: {
            deviceId: localStorage.getItem('camera', cameraId)
          }
        },
        decoder: {
          readers: ["ean_reader", "code_128_reader"]
        }
      },
      function(err) {
        if (err) {
          errors = [...errors, err.toString()];
          console.log(err);
          return;
        }
        console.log("Initialization finished. Ready to start!");
        Quagga.start();
      }
    );
    console.log(Quagga.CameraAccess);
    Quagga.CameraAccess.enumerateVideoDevices().then(devices => {
      console.log('devices', devices)
      cameras = devices;
    });
  }

  setTimeout(startStream, 100) //why 100ms?

  async function setState() {
    console.log('camera', cameraId)
    console.log('quagga', Quagga)
    await tick()    
    localStorage.setItem("camera", cameraId);
      await Quagga.stop();
    await startStream();
    console.log('quagga', Quagga)
    
  }

  Quagga.onProcessed(function(result) {
    var drawingCtx = Quagga.canvas.ctx.overlay,
      drawingCanvas = Quagga.canvas.dom.overlay;

    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(
          0,
          0,
          parseInt(drawingCanvas.getAttribute("width")),
          parseInt(drawingCanvas.getAttribute("height"))
        );
        result.boxes
          .filter(function(box) {
            return box !== result.box;
          })
          .forEach(function(box) {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: "green",
              lineWidth: 2
            });
          });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
          color: "#00F",
          lineWidth: 2
        });
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(
          result.line,
          { x: "x", y: "y" },
          drawingCtx,
          { color: "red", lineWidth: 3 }
        );
      }
    }
  });

  Quagga.onDetected(data => {
    results = [...results, data.codeResult];
  });

  onDestroy(() => {
    Quagga.stop();
  });
</script>

<style>
  #quagga {
    /* @apply mt-8; */
    /* width: 640px;
    height: 480px; */
  }
  :global(#quagga) > br {
    display: none;
  }
  :global(#quagga) > * {
    @apply max-w-full h-auto block;
  }

  :global(.drawingBuffer) {
    @apply absolute top-0 left-0 right-0 max-w-full;
  }
</style>

<div class="absolute inset-0 flex flex-wrap justify-center content-center">
  <div
    class="backdrop"
    on:click={() => history.pushState({}, '', '/products')} />
  <div class="relative bg-white p-4 inline-block shadow-2xl">

    {#if errors.length}
      <div>Errors: {JSON.stringify(errors)}</div>
    {/if}

    <div class="text-xs overflow-hidden w-64">
      {cameraId}
      
      <select bind:value={cameraId} on:change={setState}>
        {#each cameras as camera}
          <option value={camera.deviceId} selected={camera.deviceId==cameraId} >{camera.label}</option>
        {/each}
        <option value="fake">fake</option>
      </select>
    </div>

    <div class="container max-w-full relative overflow-hidden" style="max-height: 50vh">

      <div id="quagga">
        {#if false}
          <video src="" />
          <canvas />
        {/if}

      </div>
    </div>

    <Links codes={results} />
    <div />
  </div>
</div>
